import { visserApi } from "./visserApi";
const getAllArticlesByWorkOrderID = (workOrderId) => {
    return visserApi.get(`material/GetAllArticlesByWorkOrderID/${workOrderId}`);
};
const CreateMaterial = (materialDto) => {
    return visserApi.post('material/Create', materialDto);
};
const UpdateMaterial = (Id, materialDto) => {
    return visserApi.put(`material/Update/${Id}`, materialDto);
};
const getHoursAndMaterialByID = (Id) => {
    return visserApi.get(`material/GetMaterialAndArticlesByID/${Id}`);
};
const deleteMaterial = (Id) => {
    return visserApi.delete(`material/Delete/${Id}`);
};
const updateMaterialPosition = async (updateQuotationAmountPosition) => {
    return await visserApi.put(`material/UpdateMaterialPosition`, updateQuotationAmountPosition);
};
const updateBulkMaterial = async (updateBulkMaterial) => {
    return await visserApi.put(`material/UpdateBulkHourAndMaterial`, updateBulkMaterial);
};
const MaterialApi = {
    getAllArticlesByWorkOrderID,
    CreateMaterial,
    UpdateMaterial,
    getHoursAndMaterialByID,
    deleteMaterial,
    updateMaterialPosition,
    updateBulkMaterial
};
export default MaterialApi;
